import React, { useState, useEffect } from 'react'
import { FaBars, FaCaretDown } from 'react-icons/fa'
import {
    Nav,
    NavbarContainer,
    NavLogo,
    ImgLogo,
    MobileIcon,
    NavMenu,
    NavLinks,
    DropdownMenu,
    DropdownLink,
    NavBtn,
    NavBtnLink
} from './NavbarElements'
const Navbar = (props) => {
    const [scrollNav, setScrollNav] = useState(false)
    const changeNav = () => {
        if (window.scrollY >= 122) {
            setScrollNav(true);
        } else {
            setScrollNav(false);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    }, []);

    return (
        <>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo to='/'>
                        <ImgLogo src='/images/Logo.png' />
                        <h1 className="brand-text">ProRenovaGroup</h1>
                    </NavLogo>

                    <MobileIcon >
                        <FaBars onClick={props.toggle} style={{ cursor: 'pointer' }} />
                    </MobileIcon>
                    <NavMenu>
                        <NavLinks to='/' exact activeClassName="active">Home</NavLinks>
                        <NavLinks to='/about' exact activeClassName="active">About Us</NavLinks>
                        <NavLinks to='/services' exact activeClassName="active"> Services
                            <FaCaretDown />

                            <DropdownMenu className='dropdownMenu'>
                                <DropdownLink to='/services'>Sofa manufacture/ repair</DropdownLink>
                                <DropdownLink to='/services'>Restaurant renovation</DropdownLink>
                                <DropdownLink to='/services'>Custom Furniture</DropdownLink>
                                <DropdownLink to='/services'>And more...</DropdownLink>
                            </DropdownMenu>
                        </NavLinks>
                        <NavBtn>
                            <NavBtnLink to='/contact'>Contact Us</NavBtnLink>
                        </NavBtn>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
        </>
    )
}

export default Navbar
